const MODAL_KEY = {
  start: 'start',
  stop: 'stop',
  delete: 'delete',
};

export { MODAL_KEY };
